// extracted by mini-css-extract-plugin
module.exports = {"logout-container":"_admin-logout_logout-container__-5Ho3","description":"_admin-logout_description__3K-fi"};